import {
  checkIfAnalyticalCookieEnabled,
  checkIfCookieBannerAvailable,
  checkIfShouldShow
} from '@auto1-commons/cookie-gdpr/helpers'

type GetCookieGDPRFlags = {
  shouldShowCookieBanner: boolean
  isCookieBannerAvailable: boolean
  isAnalyticalCookieEnabled: boolean
}

export const getCookieGDPRFlags = (): GetCookieGDPRFlags => {
  const isCookieBannerAvailable = checkIfCookieBannerAvailable()

  return {
    isCookieBannerAvailable,
    shouldShowCookieBanner: checkIfShouldShow(),
    isAnalyticalCookieEnabled:
      !isCookieBannerAvailable || checkIfAnalyticalCookieEnabled()
  }
}
